import { useContext } from 'react';
import { ShareResourceContext } from '@/contexts/ShareResourceContext';

/**
 * Hook to access share resource modal functionality.
 * Use this to open the share dialog for any shareable resource.
 *
 * @example
 * ```tsx
 * const { openShareDialog } = useShareResource();
 *
 * const handleShare = () => {
 *   openShareDialog({
 *     resourceType: 'project',
 *     resourceId: project.id,
 *     resourceName: project.metadata?.name || 'Untitled',
 *   });
 * };
 * ```
 */
export const useShareResource = () => {
    const context = useContext(ShareResourceContext);

    if (!context) {
        throw new Error('useShareResource must be used within ShareResourceModalProvider');
    }

    return context;
};
